import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'ngx-action-icons',
  templateUrl: './action-icons.component.html',
  styleUrls: ['./action-icons.component.scss'],
})
export class ActionIconsComponent implements OnInit {
  @Input() view: String;
  @Input() topBar: any;
  @Output() onChangeView = new EventEmitter<String>();
  @Output() onRefreshClick = new EventEmitter<boolean>();
  @Output() onSettingClick = new EventEmitter();

  constructor() {}

  ngOnInit() {}

  onviewchange(value: String) {
    this.onChangeView.emit(value);
  }
  onrefreshclick(value: boolean) {
    this.onRefreshClick.emit(value);
  }
}
